import {InjectionToken} from "@angular/core";
import {AdvanceFilterParamType, IAdvanceFilter} from "./components/advance-filter";


export interface IAppliedFiltersUpdater<T> {
    update(filter:Partial<IAdvanceFilter<T>>):void;
    filterClose(filter:Partial<IAdvanceFilter<T>>):void;
}

export const IAppliedFiltersUpdaterToken = new InjectionToken<IAppliedFiltersUpdater<AdvanceFilterParamType>>('IAppliedFiltersUpdaterToken');
